// extracted by mini-css-extract-plugin
module.exports = {"gwMediaSidebarWrapper":"MediaSideBar_gwMediaSidebarWrapper__eEito","player":"MediaSideBar_player__PhUiU"};